import axios from "axios";
import { API } from "../../constants";

// fetches particular student information from directus users
export const getStudentInformation = (id: number) => {
    return axios.get(API + `users/${id}?fields=*.*`)
};

// fetch students based on teacher
export const getStudentsList = (gradeSectionId: number) => {
    console.log("Grade-section id: ", gradeSectionId);
    return axios.get(API + `items/student_profile_grade_section?filter[grade_section_id]=${gradeSectionId}&fields=id,student_profile_id.user.*.*,student_profile_id.contact_no`);
};

// fetch particular student profile details
export const getStudentProfile = (studentId: number) => {
    return axios.get(API + `items/student_profile?filter[user]=${studentId}&single=1&fields=address,contact_no,id,school.*.*,gradelist.*.*.*`); //  address,contact_no,id,school.*.*,gradelist.*.*.*  *.*.*
};

// fetch all available assessment & homeworks info for particular student
export const getStudentAssessmentData = (studentId: number) => {
    return axios.get(API + `items/assessment_attempted?filter[student]=${studentId}&fields=id,assessment.category,current_status,created_on,attempted_on,total_score,total_bonus,attempted_wrong,attempted_right,total_time_taken`);
    // id,current_status,created_on,attempted_on,total_score,total_bonus,attempted_wrong,attempted_right,total_time_taken
};

// delete existing student's profile picture
export const deleteProfileImage = (fileId: number) => {
    return axios.delete(API + `files/${fileId}`);
};